import { __ } from '@wordpress/i18n';
import { Placeholder } from '@wordpress/components';
import { useBlockProps } from '@wordpress/block-editor';

const Edit = ( props ) => {
	const blockProps = useBlockProps();

	return (
		<div { ...blockProps }>
			<Placeholder label={ __( 'Archive Collection (Legacy)', 'learnpress-collections' ) }>
				<div>
					{ __(
						'Display full content of Archive Collection, can not edit.',
						'learnpress-collections'
					) }
				</div>
			</Placeholder>
		</div>
	);
};

export default Edit;
